import {Payment} from './types';

export enum PaymentActionTypes {
    SetPayment = 'Payment/SetPayment',
}

export type PaymentActions =
    | { type: PaymentActionTypes.SetPayment, payment: Payment };
